export default __webpack_public_path__ + "141865df45b802f81e62003347fc8c19.png";